import { AlertCircle, Search, Database, type LucideIcon } from 'lucide-react';

interface EmptyStateProps {
  variant?: 'no-data' | 'no-results' | 'error';
  title: string;
  description?: string;
  icon?: LucideIcon;
  action?: {
    label: string;
    onClick: () => void;
  };
}

export function EmptyState({
  variant = 'no-data',
  title,
  description,
  icon,
  action,
}: EmptyStateProps) {
  // Default icons based on variant
  const DefaultIcon =
    icon || (variant === 'error' ? AlertCircle : variant === 'no-results' ? Search : Database);

  return (
    <div className="flex flex-col items-center justify-center py-12 px-4">
      <DefaultIcon size={48} className="text-mist/30 mb-4" />
      <h3 className="text-parchment text-lg font-medium mb-2">{title}</h3>
      {description && <p className="text-mist text-sm text-center max-w-md mb-4">{description}</p>}
      {action && (
        <button
          onClick={action.onClick}
          className="px-4 py-2 bg-rune/20 text-rune border border-rune/30 rounded-lg hover:bg-rune/30 transition-colors text-sm"
        >
          {action.label}
        </button>
      )}
    </div>
  );
}
